import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MenuItem } from '../../interfaces/menu-item';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { NgFor } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TranslatePipe, TranslateService, _ } from "@ngx-translate/core";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MatButtonModule,
    MatToolbarModule,
    MatMenuModule,
    MatDividerModule,
    NgFor,
    RouterModule,
    MatSidenavModule,
    CommonModule,
    TranslatePipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})

export class HeaderComponent implements OnInit {
  @Output() changeLang = new EventEmitter<string>();
  menuOpen: boolean = false;
  menuItems: MenuItem[] = [];
  isMobile: boolean = false;

  constructor(private translate: TranslateService, private router: Router, private breakpointObserver: BreakpointObserver) { }

  ngOnInit(): void {
    this.menuItems = [
      {
        label: "menu.bouncy-castles",
        link: "/bouncy-castle",
        isIcon: false
      },
      {
        label: "menu.sweets-and-refreshments",
        link: "/sweets-and-drinks",
        isIcon: false
      },
      {
        label: "menu.play-equipment",
        link: "/toys",
        isIcon: false
      }
    ]

    this.breakpointObserver
      .observe(['(max-width: 900px)'])
      .subscribe((result) => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          // Add the "home" icon item for mobile
          this.addHomeIconToMenuItems();
        } else {
          // Remove the "home" icon if switching back to desktop
          this.removeHomeIconFromMenuItems();
        }
      });
  }

  navigateToContact() {
    if (this.router.url.startsWith('/home')) {
      // If on the same page, scroll to the contact section
      this.scrollToSection('contact-section');
    } else {
      // Navigate to the home page with the fragment for the contact section
      this.router.navigate(['/home'], { fragment: 'contact-section' })
        .then(() => this.scrollToSection('contact-section'));
    }
  }

  private scrollToSection(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  private addHomeIconToMenuItems() {
    const homeItem = {
      label: '', // No label, just the icon
      link: '/home',
      isIcon: true, // Custom property to identify this item as an icon
    };

    // Check if it already exists to avoid duplicates
    if (!this.menuItems.some((item) => item.isIcon)) {
      this.menuItems.unshift(homeItem);
    }
  }

  private removeHomeIconFromMenuItems() {
    this.menuItems = this.menuItems.filter((item) => !item.isIcon);
  }

  protected useLanguage(language: string): void {
    this.changeLang.emit(language);
  }

  protected langMenuOpened(): void {
    this.menuOpen = true;
  }

  protected langMenuClosed(): void {
    this.menuOpen = false;
  }

  translateMenuItems(): void {
    this.menuItems.forEach(item => {
      this.translate.get(item.label).subscribe((translatedLabel: string) => {
        item.label = translatedLabel;
      });
    });
  }
}
